import { ImageRulesType, ImageVariantIdType } from 'utils/apiList/images'
import { SegmentOptionType } from 'features/CategoryAndPosisi/components/Segment'
import { CategoryBannerType } from './Category'
import { DndDataType, ImageObjectType } from './CatalogueAddEdit'

export type ImageVersionTypeIdType = 1 /* old */ | 2 /* Homepage revamp */

export type ImagePayloadType = {
  image_url_small: string
  image_url_medium: string
  image_url_large: string
  version_type_id: ImageVersionTypeIdType
}
export type DialogType = {
  mode: '' | 'DND_CATEGORY_L2' | 'DND_CATEGORY_BANNER'
  dndData: DndDataType[]
}

export type ImageStateType = {
  image: Nullable<ImagePayloadType>
  file: Nullable<File>
  imageToPreview: string
}

export type BannerFormType = CategorySchedulerType & {
  uniqueKey: string
  bannerImageFile: Nullable<File>
  bannerImagePreview: string
  banner_name: string
  banner_url: string
  banner_active: boolean
}

export type CategorySchedulerType = {
  startDate: string
  startTime: string
  endDate: string
  endTime: string
}

export enum CategoryTypeEnum {
  INSTANT = 1,
  SUPER = 2,
}

export type FormSegmentType = {
  type_id: number
  segment_type_id: number
  segment_type_name: string
  segment_type_total_user: number
  name: string
}

export type SubCategoryType = {
  end_time: string
  is_all_day: boolean
  category_active: boolean
  category_name: string
  category_schedule_id: number
  category_image: string
  start_time: string
  category_id: number
  super_image_url: string
  destination_url: string
  category_type: number
  category_label: string
  end_date: string
  start_date: string
  icon_url: string
  category_id_fe: string
  startDate: string
  endDate: string
  startTime: string
  endTime: string
  categoryImageOld: Nullable<ImageObjectType>
}

export type CategoryFormType = {
  category_label: string
  category_type: CategoryTypeEnum
  segment: FormSegmentType[]
  imageTabbingFile: Nullable<File>
  imageTabbing: Nullable<ImagePayloadType>
}

export type CategoryBannerListType = BannerFormType & Partial<CategoryBannerType>

export type InitialStateType = {
  isLoading: boolean
  imageRules: Record<ImageVariantIdType, ImageRulesType> | ObjectNullType
  categoryImage: {
    categoryImageNew: ImageStateType
    categoryImageOld: ImageStateType
  }
  banner: {
    isAddNewBanner: boolean
    selectedBannerToEdit: Nullable<CategoryBannerListType>
    form: BannerFormType
    list: CategoryBannerListType[]
  }
  scheduler: CategorySchedulerType
  form: CategoryFormType
  segmentOptions: SegmentOptionType[]
  imageURLToPreview: string
  dialog: DialogType
  subCategories: SubCategoryType[]
}

export type PayloadActionUpdateBannerType = InitialStateType['banner']['list'][number]

export type PayloadSetFormType = {
  key?: keyof CategoryFormType
  value: CategoryFormType[keyof CategoryFormType] | CategoryFormType
}

export type PayloadActionBannerFormType = {
  key: keyof BannerFormType
  value: BannerFormType[keyof BannerFormType]
}

export type SetCategorySchedulerPayloadType = {
  key?: keyof CategorySchedulerType
  value: string | CategorySchedulerType
}
